// PR-DOCVAULT JUN03 — Company-level document slots (CR today, future
// slots can extend COMPANY_SLOTS without changing this page).
import { Building2 } from 'lucide-react';
import { EntityDocumentsPanel, COMPANY_SLOTS } from '@/components/documents/EntityDocumentsPanel';

export default function CompanyDocumentsPage() {
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-6">
      <header className="flex items-center gap-3">
        <div className="rounded-lg bg-blue-500/10 p-2 text-blue-600">
          <Building2 className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-xl font-semibold">Company documents</h1>
          <p className="text-sm text-muted-foreground">
            One copy used everywhere — appears in every vehicle pack when CR is selected.
          </p>
        </div>
      </header>
      <EntityDocumentsPanel scope="company" slots={COMPANY_SLOTS} />
    </div>
  );
}
